import { isTestEnvironment } from './location';

export const showReactQueryToolingInTest = (): boolean => {
  // Note: ensures that ReactQueryDevtools not shown in E2E test
  if (
    (window.env.ENVIRONMENT !== 'production' &&
      window.env.ENVIRONMENT === 'e2e') ||
    isTestEnvironment(window.location.hostname)
  ) {
    return false;
  }
  return true;
};
